import AppView from "./views/AppView";

function App() {
  return <AppView />;
}

export default App;
